import { Controller, useFormContext } from 'react-hook-form';
import { Checkbox, TextField } from '@cencosud-cencommerce/paris-uikit';

import { noEmojiRegexExp } from '@/constants';
import {
  LABEL_NO_NUMBER,
  LABEL_STREET_NAME,
  LABEL_STREET_NUMBER
} from '@/sections/address/components/AddressForm/constants';
import type { AddressDetailsProps } from '@/sections/address/components/AddressForm/interfaces';
import { getInputStatus } from '@/sections/address/components/AddressForm/utils';
import type { AddressFormValues } from '@/sections/address/types/AddressFormValues';

export const ManualStreetAddress = (props: AddressDetailsProps) => {
  const { streetNameRef, streetNumberRef } = props;
  const { control, watch, setValue } = useFormContext<AddressFormValues>();

  const hasNoNumber = Boolean(watch('no-number'));

  return (
    <>
      <Controller
        control={control}
        name="streetName"
        render={({ field, fieldState, formState }) => (
          <TextField
            {...field}
            ref={streetNameRef}
            label={LABEL_STREET_NAME}
            disabled={!watch('commune')}
            helperText={fieldState.error?.message}
            status={getInputStatus(formState, fieldState)}
            maxLength={65}
            onChange={(e) => {
              const value = e.target.value.replace(noEmojiRegexExp, '');
              field.onChange(value);
            }}
          />
        )}
      />

      <Controller
        control={control}
        name="streetNumber"
        render={({ field, fieldState, formState }) => (
          <TextField
            {...field}
            ref={streetNumberRef}
            value={field.value === '0' ? '' : field.value}
            label={LABEL_STREET_NUMBER}
            maxLength={8}
            inputAddon={
              <Controller
                control={control}
                name="no-number"
                render={({ field: { value, ...nField } }) => (
                  <Checkbox
                    {...nField}
                    label={LABEL_NO_NUMBER}
                    labelPosition="left"
                    onChange={(e) => {
                      const value = e.target.checked ?? false;
                      if (value) {
                        setValue('streetNumber', '0');
                      } else {
                        setValue('streetNumber', '');
                      }
                      setValue('no-number', value);
                      nField.onChange(value);
                    }}
                    checked={value}
                  />
                )}
              />
            }
            onChange={(e) => {
              setValue('no-number', false);
              const value = e.target.value.replace(noEmojiRegexExp, '');
              field.onChange(value);
            }}
            helperText={hasNoNumber ? '' : fieldState.error?.message}
            disabled={hasNoNumber}
            status={getInputStatus(formState, fieldState)}
          />
        )}
      />
    </>
  );
};

ManualStreetAddress.displayName = 'ManualStreetAddress';
export default ManualStreetAddress;
